import { ReactNode, useEffect } from 'react'

import { useCurrentUser, useOrganization } from '@builddocs/data-management'
import ym from 'react-yandex-metrika'

interface YMProviderProps {
  children: ReactNode
}

export function YMParamsProvider({ children }: YMProviderProps) {
  const { user } = useCurrentUser()
  const { organization } = useOrganization()

  useEffect(() => {
    if (user && organization) {
      const [, inn, kpp] = /^(\d+)(?:-(\d+))?$/.exec(organization.inn) ?? []

      ym('userParams', {
        UserID: user.userId,
        UserRole: user?.role?.roleDescription,
        organization: {
          inn,
          kpp,
          companyName: organization.name,
        },
      })
    }
  }, [user, organization])

  return <>{children}</>
}
